import { useParams } from "react-router-dom";
import { createTourSelector } from "../../hooks/store/getters";
import { updateTourByIdSelector } from "../../hooks/store/setters";
import { useAppStore } from "../../hooks/store/useAppStore";
// import styles from './EditTourSidebar.module.css';
import TourSidebar from "./../tour-sidebar/TourSidebar";
import { updateTour } from "../../services/TourService";
import { userSelector } from "../../hooks/store/getters";
import { setAlertMessageSelector } from "../../hooks/store/setters";
import { useValidateForm } from "../../hooks/UseValidateForm";
import { setNotificationMessageSelector } from "../../hooks/store/setters";
import { tourErrorSelector } from "../../hooks/store/getters";



const EditTourSidebar = () => {
  
  const { id } = useParams();
  
  const updateTourById = useAppStore(updateTourByIdSelector);
  const currentTour = useAppStore(createTourSelector);
  const user = useAppStore(userSelector);
  const setAlertMessage = useAppStore(setAlertMessageSelector);
  const setNotificationMessage = useAppStore(setNotificationMessageSelector);
  const tourError = useAppStore(tourErrorSelector);
  const validateTour = useValidateForm();

  const handleTourSubmit = async () => {
    const payload = { 
      ...currentTour, 
      updatedBy: {
        uid: user.uid,
        name: user.userName,
        email: user.email,
        at: Date.now(),
      } 
    };
    console.log('tour error',tourError);
    console.log('payload',payload);
    const isFormValid =  validateTour.validate();

    console.log('fomr valid',isFormValid);
    if(isFormValid) {
      setNotificationMessage("");
      updateTourById(payload, id);
      await updateTour(payload);
      setAlertMessage("Tour updated successfully");
    } else {
      setNotificationMessage("Please fix the errors to submit the tour");
    }
  };

  return <TourSidebar handleTourSubmit={handleTourSubmit} pageTitle="Edit Tour"/>;
};

export default EditTourSidebar;
